import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { cn } from "@omni/utils/styles";
import classnames from "classnames";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type DeliveryTypesComponentProps = {
    allowClickAndCollect: boolean;
    allowHomeDelivery: boolean;
    className?: string;
};

const DeliveryTypesComponent = ({
    allowClickAndCollect,
    allowHomeDelivery,
    className
}: DeliveryTypesComponentProps) => {
    const { t } = useGranite();

    return (
        <div className={cn("productTile__deliveryType", className)}>
            {allowClickAndCollect && (
                <div
                    className={classnames("productTile__deliveryType-item", {
                        "pr-2": allowHomeDelivery
                    })}
                >
                    <span className="productTile__deliveryType-item_icon"></span>
                    <span className="productTile__deliveryType-item_text">
                        {t(
                            `productTile.delivery.type.${DeliveryType.ClickAndCollect}`
                        )}
                    </span>
                </div>
            )}
            {allowHomeDelivery && (
                <div className="productTile__deliveryType-item">
                    <span className="productTile__deliveryType-item_icon"></span>
                    <span className="productTile__deliveryType-item_text">
                        {t(
                            `productTile.delivery.type.${DeliveryType.HomeDelivery}`
                        )}
                    </span>
                </div>
            )}
        </div>
    );
};

export default DeliveryTypesComponent;
